import React from 'react';
import {Credential} from 'src/models';
import {compose} from 'recompose';
import {withDatabase} from '@nozbe/watermelondb/react';
import withState from 'src/redux/wrapper';
import {withObservables} from '@nozbe/watermelondb/react';
import {Q} from '@nozbe/watermelondb';
import {of} from 'rxjs';
import HookFormSelectInput from 'src/hook-form-wrapper/select-input';

interface Props {
  override?: string;
  name: string;
  label: string;
  items: any[];
  selectAll?: boolean;
  multiple?: boolean;
  showHelper?: boolean;
  canCancel?: boolean;
}

const UserCredentialSelect = ({
  override,
  name,
  label = 'Select Provider',
  items,
  selectAll = false,
  multiple = false,
  showHelper = true,
  canCancel = false,
}: Props) => {
  return (
    <HookFormSelectInput
      name={override ?? (name ? name + '.' : '') + 'credentialId'}
      label={label}
      required={false}
      multiple={multiple}
      selectAll={selectAll}
      items={items}
      showHelper={showHelper}
      canCancel={canCancel}
    />
  );
};

export default compose(
  withDatabase,
  withState,
  withObservables(['authentication'], ({authentication, database}: any) => ({
    credentials: database
      .get(Credential.table)
      .query(
        Q.where('deleted_at', null),
        Q.or(Q.where('user_id', Q.eq(null)), Q.where('user_id', Q.eq(''))),
        Q.where('_partition', authentication.selectedGroup),
        Q.sortBy('first_name', Q.desc),
        Q.sortBy('last_name', Q.desc),
      ),
  })),
  withObservables([], ({credentials, allowOther = true}: any) => {
    let items = credentials.map((credential: Credential) => {
      return {
        label: `${credential.firstName} ${credential.lastName}`,
        value: credential.id,
      };
    });
    if (allowOther) {
      items.push({
        value: 'other',
        label: 'Other',
      });
    }
    return {
      items: of(items),
    };
  }),
)(UserCredentialSelect);
